<div class="table-legend d-flex flex-wrap align-items-center gap-2 mb-2">
    <span class="fw-bold">{{ title() | translate }}</span>

    <span class="table-legend__divider"></span>

    @if (showActions()) {
        @if (showOptions()) {
            <adaa-form-checkbox
                controlName="showDimension"
                [setDefaultValue]="true"
                [boldLabel]="true"
                [label]="'data_entry.show_dimension' | translate"
                (inputChanges)="checkboxClicked.emit({ checkbox: 'options', checked: $event })"
            />
        }

        <adaa-form-checkbox
            controlName="showTargets"
            [setDefaultValue]="true"
            [boldLabel]="true"
            [label]="'data_entry.show_targets' | translate"
            (inputChanges)="checkboxClicked.emit({ checkbox: 'targets', checked: $event })"
        />
    }

    @if (showCalculation()) {
        <adaa-form-checkbox
            controlName="showCalculation"
            [setDefaultValue]="true"
            [boldLabel]="true"
            [label]="'data_entry.show_calculation' | translate"
            (inputChanges)="checkboxClicked.emit({ checkbox: 'calculation', checked: $event })"
        />
    }

    <div class="table-legend__keys d-flex flex-wrap align-items-center gap-3">
        <span class="d-flex align-items-center gap-2">
            <span class="table-legend__swatch table-legend__swatch--approved"></span>
            {{ "data_entry.approved" | translate }}
        </span>

        <span class="d-flex align-items-center gap-2">
            <span class="table-legend__swatch table-legend__swatch--in-review"></span>
            {{ "status.in_review" | translate }}
        </span>

        @if (hasAuditIssue()) {
            <span class="d-flex align-items-center gap-2">
                <span class="table-legend__swatch table-legend__swatch--audit-issue"></span>
                {{ "data_entry.has_audit_issues" | translate }}
            </span>
        }
    </div>
</div>
